module.exports = __webpack_public_path__ + "img/ecommerces-banner.9abf8ba4.gif";